namespace RedBullMOBILE360.BulkSMS {
    export interface BulkSMSExcelImportForm {
        FileName: Serenity.ImageUploadEditor;
        Message: Serenity.TextAreaEditor;
        IsMessageIncluded: Serenity.BooleanEditor;
        SendNow: Serenity.BooleanEditor;
        SendDate: Serenity.DateTimeEditor;
        SendDate2: Serenity.DateTimeEditor;
        SendDate3: Serenity.DateTimeEditor;
        SenderId: Serenity.LookupEditor;
    }

    export class BulkSMSExcelImportForm extends Serenity.PrefixedContext {
        static formKey = 'BulkSMS.BulkSMSExcelImport';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!BulkSMSExcelImportForm.init)  {
                BulkSMSExcelImportForm.init = true;

                var s = Serenity;
                var w0 = s.ImageUploadEditor;
                var w1 = s.TextAreaEditor;
                var w2 = s.BooleanEditor;
                var w3 = s.DateTimeEditor;
                var w4 = s.LookupEditor;

                Q.initFormType(BulkSMSExcelImportForm, [
                    'FileName', w0,
                    'Message', w1,
                    'IsMessageIncluded', w2,
                    'SendNow', w2,
                    'SendDate', w3,
                    'SendDate2', w3,
                    'SendDate3', w3,
                    'SenderId', w4
                ]);
            }
        }
    }
}
